import type { Borders } from "exceljs";

export const leftRightBorders = (color: string): Partial<Borders> => {
  return {
    top: {
      style: "thin",
      color: {
        argb: color,
      },
    },
    left: {
      style: "thin",
    },
    bottom: {
      style: "thin",
      color: {
        argb: color,
      },
    },
    right: {
      style: "thin",
    },
  };
};
